<template>
  <div>
    <b-alert
      show
      class="mt-3 alert-type-modif"
      :class="classAlert"
      v-b-tooltip.hover
      :title="msgToolTips"
    >
      <b-img
        width="15%"
        class="mr-2 mb-1"
        :src="
          require('@/assets/images/icons/' +
            this.srcImageName[this.modification_type - 1])
        "
      ></b-img>
      <b class="">{{ modification_type_text }}</b>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "alert-type-modification",
  data() {
    return {
      srcBase: "@/assets/images/icons/",
      variantText: ["success", "info", "danger", "warning", "dark"],
      srcImageName: [
        "success_type_modif.svg",
        "info_type_modif.svg",
        "danger_type_modif.svg",
        "warning_.svg",
        "dark_modif_.svg",
      ],
      classAlertName: [
        "alert-type-modif-success",
        "alert-type-modif-info",
        "alert-type-modif-danger",
        "alert-type-modif-warning",
      ],
    };
  },
  computed: {
    variant() {
      return this.variantText[this.modification_type - 1];
    },
    srcImg() {
      return this.srcBase + this.srcImageName[this.modification_type - 1];
    },
    classAlert() {
      return this.classAlertName[this.modification_type - 1];
    },
  },
  props: {
    // 1 = Creado, 2 = Actualizado, 3 = Eliminado, 4 = restaurado, 5 = Eliminación forzada
    modification_type: {
      type: Number,
      default: null,
    },
    modification_type_text: {
      type: String,
      default: null,
    },
    msgToolTips: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
.alert-type-modif {
  border-radius: 8px !important;
  border: 0px !important;
  font-family: "Ubuntu" !important;
  font-style: normal !important;
  font-weight: 400 !important;
}

.alert-type-modif-success {
  background: #f6ffed !important;
  color: #00761a !important;
}
.alert-type-modif-warning {
  background: #fffbe6 !important;
}
.alert-type-modif-danger {
  background: #fff1f0 !important;
  color: #ac0000 !important;
}
.alert-type-modif-info {
  background: #e6f7ff !important;
  color: #004bd1 !important;
}
.alert-type-modif-dark {
  background: #e6f7ff !important;
}
</style>